import React, { useContext } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Typography } from "@mui/material"
import { useTranslation } from 'react-i18next';
import AppContext from '../../config/AppContext';
import { ReactComponent as ArrowBackIconBack } from "../../assets/subscription/leftArrow.svg";


const SubTitleBar = ({ navigation, setNavigation }) => {
    const { t } = useTranslation();
    const { mode } = useContext(AppContext);
    return (
        <>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between"
                }}
            >
                <div>
                    {navigation == "back" ? <Box display="flex" alignItems="center" gap="10px" onClick={() => setNavigation("compare-plan")}>
                        <ArrowBackIconBack
                            fontSize='large'
                            style={{
                                width: "18px",
                                fill: mode === "light" ? "#1D0B77" : "#FA9C2B",
                            }} />
                        <Typography className='cancel-plan-card-back'
                            sx={{
                                color: mode === "light" ? "#1D0B77" : "#FA9C2B",
                                cursor: "pointer",
                                font: "normal normal normal 18px/21px GothamBold !important",
                                '@media (max-width: 1600px)': {
                                    font: "normal normal normal 16px/19px GothamBold !important",
                                },
                            }}
                        >{t("RAL0125")}</Typography>
                    </Box> : <Box display="flex" alignItems="center" width={"100px"}></Box>}
                </div>

                <div>
                    {navigation == "compare-plan" && <Box display="flex" alignItems="center" gap="2px" onClick={() => setNavigation("back")}>
                        <Typography className='cancel-plan-card-back'
                            sx={{
                                color: mode === "light" ? "#1D0B77" : "#FA9C2B",
                                cursor: "pointer",
                                font: "normal normal normal 18px/21px GothamBold !important",
                                '@media (max-width: 1600px)': {
                                    font: "normal normal normal 16px/19px GothamBold !important",
                                },
                            }}
                        >{t("RAL0897")}</Typography>
                        <ArrowBackIconBack
                            fontSize='large'
                            style={{
                                width: "18px",
                                rotate: "180deg",
                                fill: mode === "light" ? "#1D0B77" : "#FA9C2B",
                            }} />
                    </Box>}
                </div>

            </div>
        </>
    )
}

export default SubTitleBar
